import { render, staticRenderFns } from "./MembershipConfigView.vue?vue&type=template&id=d5217ade&scoped=true"
import script from "./MembershipConfigView.vue?vue&type=script&lang=js"
export * from "./MembershipConfigView.vue?vue&type=script&lang=js"
import style0 from "./MembershipConfigView.vue?vue&type=style&index=0&id=d5217ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5217ade",
  null
  
)

export default component.exports